// Spanish dictionary.
// Empty for now — keys not present here fall back automatically to the English
// dictionary in I18nProvider. Add Spanish translations as they become available.
const es: Record<string, string> = {};
export default es;
